import axios from "../http";

class ProjectManage {
  // 电商仓项目
  getProjectList(currentPage, warehouseId, projectName, status) {
    const url = `/zwy/api/project/page?currentPage=${currentPage}&warehouseId=${warehouseId}&projectName=${projectName}&status=${status}`;
    return axios(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //负责人列表
  getEmployeeList() {
    const url = `/zwy/api/employee/list`;
    return axios(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //新增项目
  postAddProject(data) {
    const url = `/zwy/api/project/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //项目详情
  getProjectDetail(id) {
    const url = `/zwy/api/project/detail?id=${id}`;
    return axios(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //修改项目
  postUpdateProject(data) {
    const url = `/zwy/api/project/modify`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //新增客户
  postAddCustomer(data) {
    const url = `/zwy/api/customer/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //关闭项目
  getCloseProject(id) {
    const url = `/zwy/api/project/close?id=${id}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 客户列表
  getCustomerList(pageNo, queryStr) {
    const url = `/zwy/api/customer/page?pageNo=${pageNo}&queryStr=${queryStr}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 开启客户
  postOpenCustomerAccount(id) {
    const url = `/zwy/api/customer/update/status/on/${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 关闭客户
  postCloseCustomerAccount(id) {
    const url = `/zwy/api/customer/update/status/off/${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 面积导入
  postExcel(data) {
    const url = `/zwy/api/upload/use/area`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 服务名称列表
  getServiceNameList() {
    const url = `/zwy/api/project/get/extra/service/list`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default ProjectManage;
